<template>
                <div class="news-items mt54">
                    
                    <a href="https://mp.weixin.qq.com/s/yxY36NScuFxEYBGN_zim-w" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1694168789242781.jpg" alt="厦门市政协副主席国桂荣一行莅临融贯国际考察交流" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">08/13<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">厦门市政协副主席国桂荣一行莅临融贯国际考察交流</div>
                                <div class="desc">8月13日，厦门市政协副主席国桂荣率队莅临融贯国际（澳门）就澳门数字经济发展进行考察交流。融贯国际执行董事吴在权先生、总经理陈祥先生接待本次来访。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/yxY36NScuFxEYBGN_zim-w" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1694168693690576.png" alt="在希望的田野上，融贯国际数字赋能中药材产业升级" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">08/02<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">在希望的田野上，融贯国际数字赋能中药材产业升级</div>
                                <div class="desc">近日，融贯国际基于“星火·链网”骨干节点（珠海横琴）——横琴粤澳链打造的中药材子链被工业互联网标识赋能千行百业领航计划——“标识案例说”系列报道收录。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/yxY36NScuFxEYBGN_zim-w" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1694168392972870.jpg" alt="重磅 | 广东粤港澳大湾区认证促进中心（筹）第一届第一次理事会在广州成功召开" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">07/12<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">重磅 | 广东粤港澳大湾区认证促进中心（筹）第一届第一次理事会在广州成功召开</div>
                                <div class="desc">2023年7月12日，广东粤港澳大湾区认证促进中心（筹）第一届第一次理事会在广州成功召开，理事会候选成员参加会议，广东省市场监督管理局有关同志到会指导。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/83" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1688545828804031.jpg" alt="标识向实 · 融创未来" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">06/28<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">标识向实 · 融创未来</div>
                                <div class="desc">6 月 28 日于“2023 工业互联网标识大会（广东）暨广东省数字经济高质量创新发展论坛”在广州召开，融贯国际受邀参加，与业界共话工业互联网标识赋能数字经济。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://appimg.modaily.cn/app/szb/pc/content/202306/29/content_272373.html" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1688546166100551.png" alt="链上存证 数赋音乐产业｜融贯助力Domi音乐大赛澳门站圆满收官" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">06/26<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">链上存证 数赋音乐产业｜融贯助力Domi音乐大赛澳门站圆满收官</div>
                                <div class="desc">6月26日， 2023DOMI加拿大维多利亚国际音乐大赛澳门地区初赛在官乐怡基金会举办。澳门融贯投资科技有限公司作为澳门地区承办方，首次在音乐产业领域发起数字赋能计划，实现了链上存证的创新性突破，成功助力本次Domi音乐大赛澳门站圆满收官。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://appimg.modaily.cn/amucsite/web/index.html#/detail/9870245" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1688545604573192.png" alt="沪澳链动 科技兴国|澳门融贯亮相（第九届）上交会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">06/14<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">沪澳链动 科技兴国|澳门融贯亮相（第九届）上交会</div>
                                <div class="desc">“第九届中国（上海）国际技术进出口交易会”于6月15至17日在上海世博展览馆举行，澳门特别行政区首次参与并担任主宾城，澳门融贯投资科技有限公司作为澳门代表企业，在澳门贸易投资促进局带领下赴沪参会。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/4s1UYc9O5qt5yuiuZ3XAqA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1688545341491833.jpg" alt="桂澳携手 数赋六堡 | 澳门融贯助力梧州六堡茶数字化平台成功发布！" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">06/05<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">桂澳携手 数赋六堡 | 澳门融贯助力梧州六堡茶数字化平台成功发布！</div>
                                <div class="desc">6月5日，由梧州市茶产业发展服务中心、梧州市产业投资发展集团有限公司、数字广西集团有限公司、澳门融贯投资科技有限公司、广州国际茶叶交易中心主办，梧州市发展和改革委员会、梧州市商务局协办的“数智六堡 链上梧茶”梧州六堡茶数字化平台发布会在广西梧州举行。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/80" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1688545167681769.jpg" alt="携手鲁港澳 构建新格局 |2023第三届数字贸易创新应用峰会圆满收官" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">06/01<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">携手鲁港澳 构建新格局 |2023第三届数字贸易创新应用峰会圆满收官</div>
                                <div class="desc">6月1日，由澳门特别行政区政府经济及科技发展局、山东省工业和信息化厅、山东省国有资产监督管理委员会指导，浪潮集团有限公司、中国信息通信研究院工业互联网与物联网研究所主办，澳门融贯投资科技有限公司、浪潮云洲（山东）工业互联网有限公司、融丰科技有限公司承办，澳门工商联会、澳门质量品牌国际认证联盟、澳门厂商联合会及山东省标识解析行业协会协办的“携手鲁港澳 构建新格局”2023第三届数字贸易创新应用峰会在澳门举行。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>